import $ from "jquery";
import _ from "lodash";
import Axios from "axios";
import React from "react";
import swal from "sweetalert";
import Swal2 from "sweetalert2";
import ReactDOMServer from 'react-dom/server';
import {
  apiUrls,
  blobContainerName,
  blobSas,
  blobStorageUrl,
  blobAccount,
  ApiBaseUrl
} from "../constants/endpoints";

import * as Api from "./api";
import { openReleaseBrightreeModal } from "../pages/modal/releaseBrightreeModal";
// import moment from 'moment';
// import 'moment-timezone';
import moment from "moment-timezone"
const { BlobServiceClient } = require("@azure/storage-blob");

console.log("ApiBaseUrl:",ApiBaseUrl);
export const versionNumber = process.env.REACT_APP_VERSION_NUMBER;

// Returns true when a physician/provider display name contains the standalone token "DNU"
// (Do Not Use) — matched at a word boundary, case-insensitively — so DNU-flagged providers
// can be hidden from every physician dropdown. Legitimate names like "Dunn" are unaffected.
export const isDnuName = (name) => /\bDNU\b/i.test(name || "");
export const envinmentName = process.env.REACT_APP_ENVIRONMENT_NAME;

export const successStatusCode = 200;
export const defaultCloseModalTimeout = 3000;

export function updateInputValueInState(
  stateVariable,
  event,
  _that,
  state,
  ReactSelectOBJ
) {
  if (ReactSelectOBJ != null && ReactSelectOBJ != undefined && ReactSelectOBJ) {
    if (event == undefined) {
      stateVariable[ReactSelectOBJ["NameProp"]] = [];
      state[ReactSelectOBJ["ValidationState"]] = false;
    } else {
      stateVariable[ReactSelectOBJ["NameProp"]] = event.map((obj, index) => {
        return obj.value;
      });
      state[ReactSelectOBJ["ValidationState"]] = true;
    }
  } else if (event.target.type == "checkbox") {
    stateVariable[event.target.name] = event.target.checked;
  } else {
    stateVariable[event.target.name] = event.target.value;
  }
  _that.setState(state);
}
export function withOutEventUpdateInputValueInState(
  stateVariable,
  _that,
  state,
  value,
  name,
  ReactSelectOBJ
) {
  if (ReactSelectOBJ != null && ReactSelectOBJ != undefined && ReactSelectOBJ) {

  //   if (event == undefined) {
  //     stateVariable[ReactSelectOBJ["NameProp"]] = [];
  //     state[ReactSelectOBJ["ValidationState"]] = false;
  //   } else {
  //     stateVariable[ReactSelectOBJ["NameProp"]] = event.map((obj, index) => {
  //       return obj.value;
  //     });
  //     state[ReactSelectOBJ["ValidationState"]] = true;
  //   }
  // } 
  // else if (event.target.type == "checkbox") {
  //   stateVariable[event.target.name] = event.target.checked;
  // }
  }
    stateVariable[name] = value;
  
  _that.setState(state);
}
const apiClient = Axios.create({
  baseURL: ApiBaseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});
export function objToQueryString(obj) {
  const keyValuePairs = [];
  for (const key in obj) {
    keyValuePairs.push(
      encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
    );
  }
  return "?" + keyValuePairs.join("&");
}

/**
 * Return the first of two props whose value is not undefined.
 *
 * @param {object} obj
 * @param {string|symbol} keyA
 * @param {string|symbol} keyB
 * @param {object} [opts]
 * @param {boolean} [opts.own=true]            // only own props? if false, include prototype
 * @param {*}       [opts.defaultValue]        // fallback when neither is usable
 * @param {boolean} [opts.requireNonEmpty=false] // treat {} as invalid
 * @returns {{ ok: boolean, which: string|symbol|null, value: any }}
 */
export function getEitherProp(obj, keyA, keyB, opts = {}) {
  const {
    own = true,
    defaultValue = undefined,
    requireNonEmpty = false
  } = opts;

  // Guard: null/undefined or not an object/function
  if (obj == null || (typeof obj !== "object" && typeof obj !== "function")) {
    return { ok: false, which: null, value: defaultValue };
  }

  // Optional "empty object" guard (own enumerable keys)
  if (requireNonEmpty && Object.keys(obj).length === 0) {
    return { ok: false, which: null, value: defaultValue };
  }

  const has = own
    ? (o, k) => Object.hasOwn(o, k)
    : (o, k) => k in o;

  // prefer keyA; if its value is undefined, fall back to keyB
  if (has(obj, keyA) && obj[keyA] !== undefined) {
    return { ok: true, which: keyA, value: obj[keyA] };
  }
  if (has(obj, keyB) && obj[keyB] !== undefined) {
    return { ok: true, which: keyB, value: obj[keyB] };
  }

  return { ok: false, which: null, value: defaultValue };
}


export function isValidZipCode(zipCode) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)|(^\d{5}\d{4}$)/.test(zipCode);
}
export function updateInputSelectValueInState(
  stateVariable,
  event,
  controlName,
  _that,
  state,
  ReactSelectOBJ
) {
  if (ReactSelectOBJ != null && ReactSelectOBJ != undefined && ReactSelectOBJ) {
    if (event == undefined) {
      stateVariable[ReactSelectOBJ["NameProp"]] = [];
      state[ReactSelectOBJ["ValidationState"]] = false;
    } else {
      stateVariable[ReactSelectOBJ["NameProp"]] = event.map((obj, index) => {
        return obj.value;
      });
      state[ReactSelectOBJ["ValidationState"]] = true;
    }
  } else {
    stateVariable[controlName] = event.value;
  }
  _that.setState(state);
}

export function updateEmailInputValueInState(
  stateVariable,
  event,
  _that,
  state,
  ReactSelectOBJ
) {
  if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(event.target.value)) {
    UpdateCustomElementValidation(event, true);
  } else {
    UpdateCustomElementValidation(event, false);
  }
  stateVariable[event.target.name] = event.target.value;
  _that.setState(state);
}

export function isValidEmail(email) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
}

export function getFormattedPhoneNum( input ) {
    if(input=="" || input==null){
      return "";
    }
    let output = "(";
    input.replace( /^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function( match, g1, g2, g3 )
        {

          if ( g1.length ) {
            output += g1;
            if ( g1.length == 3 ) {
                output += ")";
                if ( g2.length ) {
                    output += " " + g2; 
                    if ( g2.length == 3 ) {
                        output += " - ";
                        if ( g3.length ) {
                            output += g3;
                        }
                    }
                }
             }
          }
        }       
      );        
    return output;
   }
export function showSuccessAlert(msg, type, title) {
  swal({
    title: title,
    text: msg,
    icon: type,
  });
}

// ── Shared API-error surface ────────────────────────────────────────────────
// Every API response now carries errorCode / recoverySteps / message on the shared base model.
// These helpers are the ONE place that reads and renders them, so every failure surface (toasts,
// the release resident-status modal, the manual link dialog) shows the same thing.

/** Minimal HTML escaping for values interpolated into a Swal2 html body. */
export function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * Pull the catalogued error fields out of an axios response, an axios error, or a raw data
 * object. Casing guarded both ways. Never returns a stack/exception dump — only the catalogued
 * message. Branch on `success` (responses are HTTP 200 with success:false by convention).
 */
export function extractApiError(source) {
  // Accept: axios response ({data}), axios error ({response:{data}}), or a bare data object.
  const data =
    source?.data ??
    source?.response?.data ??
    (source && typeof source === "object" ? source : {}) ??
    {};
  const errorCode = data.errorCode ?? data.ErrorCode ?? null;
  const recoverySteps = data.recoverySteps ?? data.RecoverySteps ?? null;
  const rawMessage = data.message ?? data.Message ?? "";
  // Shorter/alternate wording — useful for condensed surfaces (toasts) vs full dialogs.
  // May be null; callers fall back to `message`.
  const rawAlternate = data.alternateMessage ?? data.AlternateMessage ?? "";
  const success = (data.success ?? data.Success) === true;
  const statusCode = data.statusCode ?? data.StatusCode ?? source?.response?.status ?? null;
  return {
    success,
    errorCode: errorCode || null,
    // Never surface an empty message — the caller decides the generic fallback.
    message: typeof rawMessage === "string" ? rawMessage : "",
    alternateMessage:
      typeof rawAlternate === "string" && rawAlternate.trim() ? rawAlternate : null,
    recoverySteps: typeof recoverySteps === "string" && recoverySteps.trim() ? recoverySteps : null,
    statusCode,
  };
}

/**
 * Build the shared error body HTML: message headline, an optional "How to fix this" block with
 * line breaks preserved, and a small click-to-copy error code. Used by showApiError; also handy
 * for embedding the same markup in a modal footer.
 */
export function buildApiErrorHtml({ message, alternateMessage, errorCode, recoverySteps }, opts = {}) {
  // `condensed` prefers the shorter alternateMessage when the API supplied one (toasts, tight
  // surfaces); the full `message` remains the default headline. Falls back to message when null.
  const preferred = opts.condensed && alternateMessage ? alternateMessage : message;
  const headline = preferred && preferred.trim() ? preferred : "An unexpected error occurred.";
  let html = `<div class="fc-apierr-msg" style="text-align:left;font-size:1rem;">${escapeHtml(headline)}</div>`;
  if (recoverySteps && recoverySteps.trim()) {
    // white-space:pre-wrap keeps numbered steps (1) … 2) …) on their own lines.
    html +=
      `<div class="fc-apierr-steps" style="text-align:left;margin-top:12px;padding:10px 12px;` +
      `background:#f3f6f9;border-radius:6px;">` +
      `<div style="text-transform:uppercase;font-size:0.7rem;font-weight:600;color:#7e8299;margin-bottom:4px;">How to fix this</div>` +
      `<div style="white-space:pre-wrap;font-size:0.9rem;">${escapeHtml(recoverySteps)}</div>` +
      `</div>`;
  }
  if (errorCode) {
    html +=
      `<div style="text-align:right;margin-top:12px;">` +
      `<span id="fc-apierr-code" title="Click to copy" style="cursor:pointer;font-size:0.75rem;color:#7e8299;" data-code="${escapeHtml(errorCode)}">` +
      `${escapeHtml(errorCode)} <i class="far fa-copy"></i></span></div>`;
  }
  return html;
}

/**
 * The shared error display. Route API failures here rather than hand-rolling per screen.
 * @param source axios response / error / data object, OR a pre-extracted {message,errorCode,recoverySteps}.
 * @param opts   { title }
 */
export function showApiError(source, opts = {}) {
  const info =
    source && (source.message !== undefined || source.errorCode !== undefined) && source.data === undefined && source.response === undefined
      ? source // already extracted
      : extractApiError(source);
  Swal2.fire({
    title: opts.title || "Something went wrong",
    html: buildApiErrorHtml(info, { condensed: opts.condensed === true }),
    icon: "error",
    showCloseButton: true,
    confirmButtonText: "OK",
    didOpen: () => {
      const el = document.getElementById("fc-apierr-code");
      if (!el) return;
      el.addEventListener("click", () => {
        const code = el.getAttribute("data-code") || "";
        const done = () => {
          const prev = el.innerHTML;
          el.innerHTML = `${escapeHtml(code)} <span style="color:#1e8a5b;">copied</span>`;
          setTimeout(() => (el.innerHTML = prev), 1500);
        };
        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    },
  });
}

export function showSuccessAlertAutoClose(msg, type, title, timer) {
  swal({
    title: title,
    text: msg,
    icon: type,
    timer: timer,
    buttons: false,
  });
}
export const SweetAlertWithValidation = (array) => {
  const messageList = array.map((message, index) => (
    `<li key=${index}>${message}</li>`
  ));

  const messageHtml = `<div><ul>${messageList.join('')}</ul></div>`;

  Swal2.fire({
    title: '',
    html: messageHtml,
    icon: 'error',
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: 'OK',
    confirmButtonAriaLabel: 'OK',
  });
};

/**
 * Step column definitions for Brightree validation table (order matches display).
 * Each key maps backend error substrings to a step; first match wins.
 */
const CMN_VALIDATION_STEP_COLUMNS = [
  { key: "patient", label: "Patient in Brightree" },
  { key: "primary_insurance", label: "Primary insurance" },
  { key: "so_template", label: "SO template" },
  { key: "so_insurance", label: "SO insurance & items" },
  { key: "cmn", label: "CMN" },
  { key: "other", label: "Other" },
];

/** Resident-level step keys; order-level steps show "—" when resident has any of these. */
const CMN_VALIDATION_RESIDENT_LEVEL_KEYS = ["patient", "primary_insurance", "so_template"];
const CMN_VALIDATION_ORDER_LEVEL_KEYS = ["so_insurance", "cmn", "other"];

/** Patterns to map backend error message (after "Resident X: ") to step key. Checked in order. */
const CMN_VALIDATION_MESSAGE_TO_STEP = [
  { pattern: /patient record not found in brightree/i, key: "patient" },
  { pattern: /primary insurance is not set up in brightree for this patient/i, key: "primary_insurance" },
  { pattern: /unable to verify patient insurance/i, key: "primary_insurance" },
  { pattern: /sales order template is missing or not linked/i, key: "so_template" },
  { pattern: /sales order template not found in brightree/i, key: "so_template" },
  { pattern: /primary insurance is not set up on the sales order template/i, key: "so_template" },
  { pattern: /unable to verify sales order template insurance/i, key: "so_template" },
  { pattern: /sales order not found in brightree/i, key: "so_insurance" },
  { pattern: /does not have primary insurance with.*include this payor level/i, key: "so_insurance" },
  { pattern: /line items.*not associated with insurance \(payors\)/i, key: "so_insurance" },
  { pattern: /cmn must be created and attached/i, key: "cmn" },
  { pattern: /line items must be linked to the cmn/i, key: "cmn" },
  { pattern: /unable to verify sales order in brightree/i, key: "other" },
];

/**
 * Parses a single CMN validation error string into { residentKey, residentDisplayName, stepKey, shortLabel, fullMessage }.
 * Resident key is normalized for grouping (e.g. "LastName, FirstName" without "(Brightree SO ...)").
 */
function parseCMNValidationError(msg) {
  if (typeof msg !== "string" || !msg.trim()) return null;
  const withResident = msg.match(/^Resident\s+(.+?):\s+(.+)$/s);
  if (withResident) {
    const rawName = withResident[1].trim();
    const message = withResident[2].trim();
    const residentKey = rawName.replace(/\s*\(Brightree\s+SO\s+[^)]+\)\s*$/i, "").trim();
    const residentDisplayName = residentKey || "—";
    let stepKey = "other";
    for (let i = 0; i < CMN_VALIDATION_MESSAGE_TO_STEP.length; i++) {
      if (CMN_VALIDATION_MESSAGE_TO_STEP[i].pattern.test(message)) {
        stepKey = CMN_VALIDATION_MESSAGE_TO_STEP[i].key;
        break;
      }
    }
    const col = CMN_VALIDATION_STEP_COLUMNS.find((c) => c.key === stepKey);
    const shortLabel = col ? col.label : "Fix in Brightree";
    return { residentKey, residentDisplayName, stepKey, shortLabel, fullMessage: msg };
  }
  return { residentKey: null, residentDisplayName: "—", stepKey: "other", shortLabel: "Fix in Brightree", fullMessage: msg };
}

/**
 * Builds resident-keyed map of steps that need to be done. Also returns global errors (no resident).
 */
function buildCMNValidationResidentMap(errors) {
  const residentMap = new Map();
  const globalErrors = [];
  for (const msg of errors) {
    const parsed = parseCMNValidationError(msg);
    if (!parsed) continue;
    if (parsed.residentKey === null) {
      globalErrors.push(parsed.fullMessage);
      continue;
    }
    // Some resident-specific errors (e.g. Brightree rejected order creation)
    // should also be surfaced as a global banner under the modal title.
    if (CMN_VALIDATION_GLOBAL_MESSAGE_PATTERNS.some((re) => re.test(parsed.fullMessage))) {
      globalErrors.push(parsed.fullMessage);
    }
    if (!residentMap.has(parsed.residentKey)) {
      residentMap.set(parsed.residentKey, { displayName: parsed.residentDisplayName, steps: {} });
    }
    const row = residentMap.get(parsed.residentKey);
    if (!row.steps[parsed.stepKey]) {
      row.steps[parsed.stepKey] = { shortLabel: parsed.shortLabel, fullMessage: parsed.fullMessage };
    }
  }
  return { residentMap, globalErrors };
}

/** Insurance-related categories for the main table. Other categories shown separately if present. */
const CMN_INSURANCE_CATEGORIES = {
  patient: ["PrimaryInsuranceMissing", "VerifyPatientInsuranceError"],
  soTemplate: [
    "SoTemplateMissing",
    "SoTemplateNotFound",
    "SoTemplateNoPrimaryInsurance",
    "SoTemplatePayPctZero",
    "SoTemplateVerifyError",
  ],
};

/**
 * Error message patterns that should also appear as a global banner directly
 * under \"Brightree requirements not met\" in the validation modal, even when
 * they are tied to a specific resident row. This makes critical failures
 * (like Brightree rejecting order creation) much more visible.
 */
const CMN_VALIDATION_GLOBAL_MESSAGE_PATTERNS = [
  /brightree rejected order creation/i,
  /order creation failed in brightree/i,
];

/**
 * Builds structured modal data from ErrorGroups for the branded release modal.
 * Returns { globalMessages, columns, rows } where each row is
 * { displayName, cells: { <colKey>: { state: "done"|"todo"|"na", text?, title? } } }.
 * Columns: Resident | Primary insurance (patient) | Primary on SO template, plus
 * an "other" column carrying any non-insurance requirement text.
 */
function buildCMNErrorGroupsData(errorGroups) {
  const byCategory = new Map();
  const globalMessages = [];
  // PBI-3674: resident display name -> resident id (index-aligned ResidentIds from the API),
  // so each row can be selected and repushed by id.
  const idByName = new Map();
  for (const g of errorGroups) {
    const cat = (g.category || g.Category || "").trim();
    const names = g.residentNames || g.ResidentNames || [];
    const ids = g.residentIds || g.ResidentIds || [];
    const globalMsg = g.globalMessage || g.GlobalMessage;
    if (globalMsg) {
      globalMessages.push(globalMsg);
    } else if (names.length > 0) {
      byCategory.set(cat, { title: g.title || g.Title || "", names });
      names.forEach((n, i) => {
        const id = Number(ids[i]);
        if (!idByName.has(n) && id > 0) idByName.set(n, id);
      });
    }
  }

  const patientCats = CMN_INSURANCE_CATEGORIES.patient;
  const soTemplateCats = CMN_INSURANCE_CATEGORIES.soTemplate;
  const isInsuranceCategory = (c) => patientCats.includes(c) || soTemplateCats.includes(c);
  const hasPatientIssue = (name) =>
    patientCats.some((c) => (byCategory.get(c)?.names || []).includes(name));
  const hasSoTemplateIssue = (name) =>
    soTemplateCats.some((c) => (byCategory.get(c)?.names || []).includes(name));

  const otherGroups = [...byCategory.entries()].filter(([c]) => !isInsuranceCategory(c));
  const otherByResident = new Map();
  for (const [, v] of otherGroups) {
    (v.names || []).forEach((n) => {
      const list = otherByResident.get(n) || [];
      list.push(v.title);
      otherByResident.set(n, list);
    });
  }

  const allResidents = new Set();
  for (const [, v] of byCategory) v.names.forEach((n) => allResidents.add(n));
  const sortedResidents = Array.from(allResidents).sort();

  const columns = [
    { key: "patient", label: "Primary insurance (patient)" },
    { key: "so_template", label: "Primary on SO template" },
  ];
  if (otherByResident.size > 0) columns.push({ key: "other", label: "Other requirements" });

  const rows = sortedResidents.map((name) => {
    const patientBad = hasPatientIssue(name);
    const soBad = hasSoTemplateIssue(name);
    const cells = {
      patient: patientBad ? { state: "todo" } : { state: "done" },
      // When patient-level failed, SO template was not validated yet -> "—" instead of a misleading ✓
      so_template: soBad ? { state: "todo" } : patientBad ? { state: "na" } : { state: "done" },
    };
    if (otherByResident.has(name)) {
      const text = otherByResident.get(name).join(", ");
      cells.other = { state: "todo", text, title: text };
    } else if (otherByResident.size > 0) {
      cells.other = { state: "done" };
    }
    return { displayName: name, residentId: idByName.get(name) || 0, cells };
  });

  // Every row here failed validation, so all rows with a known id are selectable for repush.
  const selectable = rows.some((r) => r.residentId > 0);
  return { globalMessages, columns, rows, selectable };
}

/**
 * Builds structured modal data from the flat per-resident error strings.
 * Returns { globalMessages, columns, rows } in the same shape used by the modal.
 */
function buildCMNValidationTableData(errors, isCmnEnabled) {
  const { residentMap, globalErrors } = buildCMNValidationResidentMap(errors);
  const columns = (isCmnEnabled
    ? CMN_VALIDATION_STEP_COLUMNS
    : CMN_VALIDATION_STEP_COLUMNS.filter((c) => c.key !== "cmn"));

  if (residentMap.size === 0) {
    // No parseable residents — surface each message as its own banner.
    return { globalMessages: errors.slice(), columns: [], rows: [], selectable: false };
  }

  const rows = [];
  for (const [, row] of residentMap) {
    const cells = {};
    for (const col of columns) {
      const step = row.steps[col.key];
      const isOrderLevel = CMN_VALIDATION_ORDER_LEVEL_KEYS.includes(col.key);
      if (step) {
        // The check ran and this resident failed it.
        const text = step.fullMessage.replace(/^Resident\s+[^:]+:\s*/i, "");
        cells[col.key] = { state: "todo", text, title: step.fullMessage };
      } else if (isOrderLevel) {
        // Order/SO-level checks only run when the resident already has a Brightree Sales Order,
        // and a passing check leaves no trace in the flat errors. We cannot prove it was verified,
        // so we never show a ✓ here — show "—" ("not verified here") instead of a misleading tick.
        cells[col.key] = { state: "na", title: "Not verified here" };
      } else {
        // Resident-level check (patient / primary insurance / SO template) always runs — a clean
        // pass is genuine, so ✓ is trustworthy.
        cells[col.key] = { state: "done" };
      }
    }
    rows.push({ displayName: row.displayName, residentId: 0, cells });
  }

  const globalMessages = globalErrors.length > 0 ? [globalErrors[0]] : [];
  // Flat error strings carry no resident ids, so repush selection is not available here.
  return { globalMessages, columns, rows, selectable: false };
}

/**
 * Shows Brightree release validation errors (e.g. "Brightree requirements not met").
 * When errorGroups is provided and non-empty: shows an insurance-focused per-resident grid; each row
 * carries the resident id (PBI-3674) so the user can select residents and repush only those.
 * Otherwise: falls back to a step grid built from the flat error strings (no selection — no ids available).
 * @param {string} title - Unused when errorGroups present; kept for API compatibility.
 * @param {string[]} errors - List of per-resident or per-issue error messages.
 * @param {function} [onRepush] - Called with the selected resident id array when the user clicks "Repush".
 * @param {Array<{category:string,title:string,residentNames?:string[],residentIds?:number[],globalMessage?:string}>} [errorGroups] - Grouped errors from the API.
 * @param {boolean} [isCmnEnabled=true] - When false, the CMN step column is hidden (feature switch TaskID 7 is off).
 */
export function showCMNValidationErrors(title, errors, onRepush, errorGroups, isCmnEnabled = true) {
  const hasGroups = Array.isArray(errorGroups) && errorGroups.length > 0;
  if (!hasGroups && (!errors || !Array.isArray(errors) || errors.length === 0)) {
    showSuccessAlert(title || "Release to Brightree cannot proceed.", "warning", "Brightree requirements not met");
    return;
  }

  let modalData;
  if (hasGroups) {
    modalData = buildCMNErrorGroupsData(errorGroups);
  } else {
    modalData = buildCMNValidationTableData(errors, isCmnEnabled);
  }

  // Repush is only offered when we have resident ids to send and a handler to send them to.
  const canRepush = modalData.selectable && typeof onRepush === "function";

  openReleaseBrightreeModal({
    mode: "validation",
    title: "Brightree requirements not met",
    data: modalData,
    onConfirm: canRepush ? onRepush : undefined,
  });
}

/**
 * PBI-3674 selective repush dialog. Shows every resident's push status (Success/Failed) with a
 * plain-language error for failed ones. Failed residents can be selected and repushed; "Repush
 * Selected" stays disabled until at least one resident is checked.
 * @param {Array} residentResults - [{residentId, residentName, status, failedStep, errorMessage}]
 * @param {Function} onRepush - called with the selected resident id array when the user confirms.
 */
export function showReleaseRepushDialog(residentResults, onRepush, apiError = null) {
  const results = Array.isArray(residentResults) ? residentResults : [];
  const failed = results.filter((r) => r && String(r.status || "").toLowerCase() === "failed");
  if (failed.length === 0) {
    showSuccessAlert("Release could not be completed. Check Brightree and try again.", "warning", "Warning!");
    return;
  }
  // Failed residents first, then alphabetical, so the actionable rows are on top.
  const sorted = [...results].sort((a, b) => {
    const failFirst =
      (String(a.status || "").toLowerCase() === "failed" ? 0 : 1) -
      (String(b.status || "").toLowerCase() === "failed" ? 0 : 1);
    if (failFirst !== 0) return failFirst;
    return String(a.residentName || "").localeCompare(String(b.residentName || ""));
  });

  openReleaseBrightreeModal({
    mode: "repush",
    title: "Release to Brightree — resident status",
    data: { results: sorted, apiError },
    onConfirm: (selectedIds) => {
      if (Array.isArray(selectedIds) && selectedIds.length > 0 && typeof onRepush === "function") {
        onRepush(selectedIds);
      }
    },
  });
}

/**
 * PBI-3674: infer the failed step/category from a backend error message when the API didn't provide an
 * explicit failedStep (e.g. pre-flight validation errors returned as flat strings). Keeps the Repush
 * dialog's status badge accurate — an insurance/physician readiness problem must not read as "Sales Order".
 * Returns a step key understood by the modal's stepLabel(), or null when the cause is unclear.
 */
export function deriveFailedStep(message) {
  const m = (message || "").toLowerCase();
  if (!m) return null;
  if (m.includes("insurance") || m.includes("payor")) return "Insurance";
  if (m.includes("physician") || m.includes("doctor")) return "Physician";
  if (m.includes("gender")) return "Setup";
  if (m.includes("cmn")) return "CMN";
  // Genuine Sales Order creation problems.
  if (
    m.includes("template") ||
    m.includes("sales order") ||
    m.includes("warehouse") ||
    m.includes("sku") ||
    m.includes("item")
  )
    return "SOCreation";
  return null;
}

/**
 * PBI-3674: full-screen blocking loader shown while a Release/Repush request is in flight, so the
 * user gets clear "in progress" feedback instead of the dialog appearing to hang on the list.
 * Pair every showBlockingLoader() with a closeBlockingLoader() in the request's then/catch.
 */
export function showBlockingLoader(message) {
  Swal2.fire({
    title: message || "Please wait…",
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => Swal2.showLoading(),
  });
}
export function closeBlockingLoader() {
  Swal2.close();
}

export function showConfirmation(

  msg,
  title,
  confirmCallback,
  cancelCallback = null,
  obj,
  buttonText="OK",
  showDenyButton=false,
  denyCallback=null,
  cancelbuttonText="Cancel"
) {
  Swal2.fire({
    title: title ? title : "Are you sure?",
    text: msg ? msg : "",
    icon: "warning",
    showCancelButton: true,
    showDenyButton:showDenyButton,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: buttonText,
    cancelButtonText:cancelbuttonText
  }).then((result) => {
    if (result.value) {
      if (_.isFunction(confirmCallback)) confirmCallback(obj);
      
    }  
     else {
      if (_.isFunction(cancelCallback)) {
        if (cancelCallback != null) {
          cancelCallback(obj);
        }
      
      }else if(_.isFunction(denyCallback) && result.isDenied){
     
        if (denyCallback != null) {
          denyCallback(obj)
        }
      }
    }
  });
}

export function showConfirmationHtml(
  html,
  title,
  confirmCallback,
  cancelCallback,
  obj,
  buttonText,
  cancelbuttonText
) {
  const resolvedTitle = title || "Are you sure?";
  const resolvedHtml = html || "";
  const resolvedButtonText = buttonText || "OK";
  const resolvedCancelbuttonText = cancelbuttonText || "Cancel";

  Swal2.fire({
    title: resolvedTitle,
    html: resolvedHtml,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: resolvedButtonText,
    cancelButtonText: resolvedCancelbuttonText,
  }).then((result) => {
    if (result.value) {
      if (_.isFunction(confirmCallback)) confirmCallback(obj);
    } else if (_.isFunction(cancelCallback) && cancelCallback != null) {
      cancelCallback(obj);
    }
  });
}

export function GetBaseUrl() {
  var getUrl = window.location;
  var baseUrl = getUrl.protocol + "//" + getUrl.host;
  return baseUrl;
}

export function GetDateTimeString(dateString) {
  var date = new Date(dateString);
  return (
   
    (date.getMonth() + 1) +
    "-" +
    date.getDate() +
    "-" +
    date.getFullYear()  +
    " " +
    date.toLocaleTimeString()
  );
}
export function GetDateString(dateString) {
  var date = new Date(dateString);
  return (
    minTwoDigit(date.getMonth() + 1) +
    "-" +
    minTwoDigit(date.getDate()) +
    "-" +
    minTwoDigit(date.getFullYear()) 
  );
}

function minTwoDigit(input) {
  if ((input + "").length == 1) return "0" + input;
  return input;
}

export const BusEntityDetailType = {
  DescriptionHtml: "DescriptionHtml",
  LogoPath: "LogoPath",
};
export function getCurrentDate(separator = "") {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${year}${separator}${month < 10 ? `0${month}` : `${month}`
    }${separator}${date}`;
}
export function UpdateCustomElementValidation(event, isValid) {
  if (isValid) {
    event.currentTarget.nextElementSibling.style.display = "";
    event.target.setCustomValidity("");
  } else {
    event.currentTarget.nextElementSibling.style.display = "block";
    event.target.setCustomValidity("Invalid field.");
  }
}

export function prependZeroIfLessThanTen(item) {
  if (item.toString().length === 1) {
    return "0" + item.toString();
  } else {
    return item;
  }
}

// PBI 4162: adds a reusable "x" clear button to every legacy jQuery DataTables
// search box, from a single place — so all 40+ LoadDataTable screens get the same
// clear behavior as the modern (React) grids. Additive, idempotent (won't duplicate
// on re-init), and fully guarded so it can never break table initialization.
function ensureDataTableSearchClear(tableId) {
  try {
    var $filter = $("#" + tableId + "_filter");
    var $input = $filter.find("input");
    if (!$filter.length || !$input.length) return;

    var toggleClear = function () {
      $filter.find(".dt-search-clear").css("display", $input.val() ? "inline-block" : "none");
    };

    if ($filter.find(".dt-search-clear").length === 0) {
      var $btn = $(
        '<button type="button" class="dt-search-clear btn btn-sm btn-outline-secondary" ' +
          'title="Clear search" aria-label="Clear search" ' +
          'style="margin-left:4px;line-height:1;padding:0 7px;">&times;</button>'
      );
      $btn.on("click", function () {
        $("#" + tableId).DataTable().search("").draw();
        $input.val("");
        toggleClear();
        $input.trigger("focus");
      });
      // Append to the .dataTables_filter container (after the <label>), NOT inside the
      // label — a <button> inside a <label> can double-fire via label click-forwarding.
      $filter.append($btn);
    }

    $input.off("input.dtSearchClear").on("input.dtSearchClear", toggleClear);
    toggleClear();
  } catch (e) {
    /* the clear-button enhancement must never break table init */
  }
}

export function LoadDataTable(tableId) {
  if ($.fn.dataTable.isDataTable("#" + tableId)) {
    $("#" + tableId).DataTable = $("#" + tableId).DataTable();
  } else {
    $("#" + tableId).DataTable({
      "order": [],
      responsive: true,
      pageLength: 25,
      lengthMenu: [
        [25, 50, 100, -1],
        [25, 50, 100, "All"],
      ],
    });
  }
  ensureDataTableSearchClear(tableId);
}
export function LoadDataTableWithButtons(tableId) {
$("#" +tableId).DataTable({
  "order": [],
  responsive: true,
  pageLength: 20,
  destroy: true,
  columnDefs: [
    { responsivePriority: 1, targets: 0 }
  ],
  dom: "<'row mb-3'<'col-sm-12 col-md-6 d-flex align-items-center justify-content-start'f><'col-sm-12 col-md-6 d-flex align-items-center justify-content-end'B>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
  "buttons": [
    {
      extend: 'csvHtml5',
      text: 'CSV',
      titleAttr: 'Generate CSV',
      className: 'btn btn-sm btn-primary mr-2'
    },
    {
      extend: 'copyHtml5',
      text: 'Copy',
      titleAttr: 'Copy to clipboard',
      className: 'btn btn-sm btn-light'
    }
  ]
});
  ensureDataTableSearchClear(tableId);
}
export function GetCurrentUser() {
  var user = localStorage.getItem("gentell-fastcare-authUser");
  return user;
}

/**
 * Execute an API call and return the result
 * @param {string} url - The API endpoint URL
 * @param {string} method - The HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {object} data - The request payload (for POST, PUT, etc.)
 * @param {object} params - The URL parameters (for GET requests)
 * @param {object} headers - Additional headers to be sent with the request
 * @returns {Promise<any>} - The API response data
 */
export async function executeApi(
  endpoint, // e.g. "/ValidateInsurance"
  method = 'GET',
  data = null,
  params = null,
  headers = {},
  baseURL = '' // Optional: default to empty
) {
  try {
    
    const response = await apiClient({
      url: endpoint,
      method,
      data,
      params,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      }
    });

    return response.data;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
}


export async function getLookupOptions(fkID) {
  const res = await Api.getRequestById(Api.Uri_GetLookupValuesByFkId, fkID);
  const data = res.data.result;

  let optionTemplate = data.map((v) => (
    <option key={v.key} value={v.key}>
      {v.value}
    </option>
  ));
  return optionTemplate;
}
export async function getLookupOptionsObject(fkID) {
  const res = await Api.getRequestById(Api.Uri_GetLookupValuesByFkId, fkID);
  const data = res.data.result;

  return data;
}
export async function getAllLookupOptions(url) {
  const res = await Api.getRequest(url);
  const data = res.data.result;

  let optionTemplate = data.map((v) => (
    <option key={v.key} value={v.key}>
      {v.value}
    </option>
  ));
  return optionTemplate;
}
export async function getAllBTLookupOptions(url) {
  const res = await Api.getRequest(url);
  const data = res.data.result;

  let optionTemplate = data.map((v) => (
    <option key={v.id} value={v.id}>
      {v.name}
    </option>
  ));
  return optionTemplate;
}
export const LookupsFK = {
  Fk_FacilityTypeID: 1,
  Fk_ProductLineID: 2,
  OrganizationID: 3,
  Fk_EHRVendorID: 5,
  Fk_WarehouseID: 6,
  Fk_ResidentStatusID: 7,
  Fk_ResidentNoOrderStatus: 1019,
  Fk_WoundInfoChangeReasons: 1024,


  Fk_ProcessorResidentNoOrderStatus: 1021,
  Fk_ClinicianResidentNoOrderStatus: 1022,
  Fk_ECPStatus: 1023,


  Fk_WoundNoOrderStatus:1020,
  Fk_fkPressureLocationID: 1002,
  Fk_fkNonPressureLocationID: 1004,
  Fk_fkNonPressureLocationSurgeryID: 1017,
  Fk_WoundAcquisitionID: 10,
  Fk_WoundTypeID: 11,
  Fk_WoundEdges: 20,
  Fk_WoundBedDescription: 17,
  Fk_WoundExudateColor: 1025,

  Fk_WoundSurroundingSkin: 18,
  Fk_WoundSkinAndUlcerTreatment: 19,
  Fk_fkPressureThiknessID: 12,
  Fk_WoundExudateAmountID: 14,
  Fk_WoundExudateTypeID: 15,
  Fk_WoundDebridementTypeID: 16,
  Fk_WoundDressingChangeFrequencyID: 22,
  Fk_WoundPrimaryDressingID: 23,
  Fk_WoundSecondaryDressingID: 24,
  Fk_fkNonPressureThiknessID: 1005,
  Fk_fkWoundSideID: 1003,
  Fk_InsuranceLevel: 28,
  Fk_WoundSevereTissueTypeID: 13,
  Fk_SignatureCredentials: 1018,

  Fk_RoleClinicianID: 3,
  Fk_IntakeProcessorID: 5,
  Fk_OutsID: 19,
    Fk_EnteralID: 20,
    Fk_fkJurisdictionID: 1027,
    FK_SeniorBiller: 4,

};
export const UserRole = 
{
  CorporateClinician:7,
  RegionalClinician:8,
  LevelI:9,
    LevelII: 10,
    MDSCoordinator: 11,

  Fk_RoleClinicianID: 3,

}
export const ResidentStatusID = 
{
  open:36,
  closed:37

}
export const ProductCategories = 
{ 
  collagen:1257,
  collagenAG:1318,
  hydrogel:1263,
  calciumAlginate:1255,
  calciumAlginateAG:1317,
  cMCFiber:1259,
  honeyFiber:1261,
  superAbsorbent:1265,
  superAbsorbent:1265,
  superAbsorbentAdherent:1320



}
export const WoundType = 
{ 
  pressure:5,
  Surgical:12,
  tubeSize:15
}
export const debridementType={
  sharp : 1027,
  enzymatic  : 1029,
  chemical:1032
}

export const exudate={
  light : 3,
  moderate : 4,
  heavy:5
}

export const mostSevereTissue={
  Epithelial : 1214,
  Granulation : 1253,
  Slough : 1298,
  Necrosis_Eschar_On_Muscle : 1299,
  Necrosis_Eschar_On_Bone:1300,
  Slough_On_Muscle:1302,
  Slough_On_Bone : 1303,
  Necrosis : 1348,
}

export const ProductLevel = 
{
  primary:1203,
  secondary:1204
}
  export const ProcessStatus = 
  {
    assessmentQueueID: 1280,
    workQueueID:1281,
    billingQueueID:1282,
    brighreeQueueID:1283,

  }
export const WoundOrientation = 
{
  right:1,
  left:2,
  upper:1,
  lower:2,
  inner:1,
  outer:2,
  anterior:1,
  posterior:2,
  medial:1,
  lateral:2,
  dorsal:1,
  distal:2,
  proximal:3,
  midline:1

}
export const OtherBodyRegionAndLocation = 
{
 bodyRegion:10011,
 woundLocation:10012,


}
export function withRateLimit(asyncFn, setLoading) {
  return async (...args) => {
    if (setLoading) setLoading(true);
    try {
      await asyncFn(...args); // Pass arguments to the actual function
    } catch (error) {
      console.error("Error executing function:", error);
    } finally {
      if (setLoading) setLoading(false);
    }
  };
}


export function replaceNullWithString(value, replaceValue) {
  if (value == null) {
    value = replaceValue != null ? replaceValue : "";
  }
  return value;
}
export function replaceNullOrEmptyWithString(targetString, replaceValue) {
  if (targetString == null) {
    return replaceValue;
  }

  if (typeof targetString === "string") {
    const normalized = targetString.trim();
    return normalized === "" ? replaceValue : normalized;
  }

  if (
    typeof targetString === "number" ||
    typeof targetString === "boolean" ||
    typeof targetString === "bigint"
  ) {
    return String(targetString);
  }

  return replaceValue;
}
export function zipCodeToTimeZone (dateTime,zipCode){

  if(dateTime=='' || dateTime==null){
    return "";
  }
  if(zipCode?.length>5){
    zipCode=zipCode?.slice(0,5)
  }
  var zipcode_to_timezone = require( 'zipcode-to-timezone' );
  var tz = zipcode_to_timezone.lookup( zipCode );
  if(tz==null){
    tz='America/New_York'
  }
  var displayCutoff = moment.tz(dateTime, 'YYYYMMDD HH:mm:ss',tz);
  const month =
  displayCutoff._d.getMonth() + 1 < 10
    ? "0" + (displayCutoff._d.getMonth() + 1)
    : displayCutoff._d.getMonth() + 1;

  const _date = displayCutoff._d.getDate() < 10 ? "0" + displayCutoff._d.getDate() : displayCutoff._d.getDate();
  let dt =   month + "-" + _date + "-" +  displayCutoff._d.getFullYear();
    return dt;
}
export function getInputStringDate(date) {
  //date= new Date();
  let dt = "";
  try {
    const month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    const _date = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    dt = date.getFullYear() + "-" + month + "-" + _date;
  } catch (ex) {
    LogError(ex,"Api Call in common.js file","getInputStringDate");
   }
  return dt;
}
export function getInputStringDateUsingMoment(date) {
  if(date==null || date._isValid==false || date._d==null){
    return null
  }
  //date= new Date();
  let dt = "";
  try {
    const month =
      date._d.getMonth() + 1 < 10
        ? "0" + (date._d.getMonth() + 1)
        : date._d.getMonth() + 1;
    const _date = date._d.getDate() < 10 ? "0" + date._d.getDate() : date._d.getDate();
    dt = date._d.getFullYear() + "-" + month + "-" + _date;
  } catch (ex) {
    LogError(ex,"Api Call in common.js file","getInputStringDate");
   }
  return dt;
}

export function getInputStringDateUsingMoment2(date) {
  //date= new Date();
  if (date == null || date._isValid == false || date._d == null) {
    return null
  }
  let dt = "";
  try {
    const month =
      date._d.getMonth() + 1 < 10
        ? "0" + (date._d.getMonth() + 1)
        : date._d.getMonth() + 1;
    const _date = date._d.getDate() < 10 ? "0" + date._d.getDate() : date._d.getDate();
    dt =   month + "-" + _date + "-" +  date._d.getFullYear();
  } catch (ex) {
    LogError(ex,"Api Call in common.js file","getInputStringDate");
   }
  return dt;
}
export function getInputStringDateFormat(date) {
  
  //date= new Date();
  let dt = "";
  try {
    const month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    const _date = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    dt =   month + "/" + _date + "/" +date.getFullYear();
  } catch (ex) {
    LogError(ex,"Api Call in common.js file","getInputStringDate");
   }
  return dt;
}
export function getInputStringDate2(date) {
  
  date= new Date();
  let dt = "";
  try {
    const month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    const _date = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    dt = date.getFullYear() + "-" + month + "-" + _date;
  } catch (ex) {
    LogError(ex,"Api Call in common.js file","getInputStringDate");
   }
  return dt;
}
export async function uploadImage(file) {
  try {
    const blobServiceClient = new BlobServiceClient(blobStorageUrl + blobSas);
    const containerClient = await blobServiceClient.getContainerClient(
      blobContainerName
    );
    var re = /(?:\.([^.]+))?$/;
    const fileExtesnion = re.exec(file.name)[1];
    const _filename = Date.now() + "." + fileExtesnion;
    let filename = _filename;

    const client = containerClient.getBlockBlobClient(filename);
    const response = await client.uploadBrowserData(file, {
      blockSize: file.size,
      concurrency: 20, // 20 concurrency
      onProgress: (ev) =>
        console.log(((ev.loadedBytes / file.size) * 100).toFixed(2)),
      blobHTTPHeaders: { blobContentType: file.type },
    });
    return response._response.status == 201
      ? `${blobStorageUrl}/${blobContainerName}/${filename}`
      : "e";
  } catch (ex) {
    LogError(ex,"Api Call in common.js file","uploadImage");
    return "e";
  }
}
export async function uploadPdfFile(file) {
  try {
    const blobServiceClient = new BlobServiceClient(blobStorageUrl + blobSas);
    const containerClient = await blobServiceClient.getContainerClient(
      blobContainerName
    );
    const _filename = Date.now() + ".pdf";
    let filename = _filename;

    const client = containerClient.getBlockBlobClient(filename);
    const response = await client.uploadBrowserData(file, {
      blockSize: file.size,
      concurrency: 20, // 20 concurrency
      onProgress: (ev) =>
        console.log(((ev.loadedBytes / file.size) * 100).toFixed(2)),
      blobHTTPHeaders: { blobContentType: file.type },
    });
    if (response._response.status === 201) {
      // Generate pre-signed URL for the uploaded file
      //const sasToken = await generateSasToken(filename);
      //const url = `${blobStorageUrl}/${blobContainerName}/${filename}?${sasToken}`;
      const url = `${blobStorageUrl}/${blobContainerName}/${filename}`;
      console.log("Uploaded PDF URL:", url);
      return url;
    } else {
      console.error("Failed to upload PDF file");
      return "e";
    }
  } catch (ex) {
    LogError(ex,"Api Call in common.js file","uploadPdfFile");
    return "e";
  }
}

export function getDifferenceInDays(date1, date2) {
  const oneDay = 1000 * 60 * 60 * 24;

  // A day in UTC always lasts 24 hours (unlike in other time formats)
  const start = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  const end = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());

  // so it's safe to divide by 24 hours
  return (start-end) / oneDay;

}
export async function LogError(errorMessage, moduleName, actionName) {
  try {
    Api.postRequest("LogException/Log/", { error:errorMessage, module:moduleName, action: actionName}, true);
  }
  catch (error) {

  }

}
export function calculatePushScore(area, exudateAmount, tissueTypeId) {
  var pushScore = 0;
  if (area <= 0) {
  }
  else if (area < (0.3).toFixed(2)) {
      pushScore = 1;
  }
  else if (area >= (0.3).toFixed(2) && area <= (0.6).toFixed(2)) {
      pushScore = 2;
  }
  else if (area >= (0.7).toFixed(2) && area <= (1.0).toFixed(2)) {
      pushScore = 3;
  }
  else if (area >= (1.1).toFixed(2) && area <= (2.0).toFixed(2)) {
      pushScore = 4;
  }
  else if (area >= (2.1).toFixed(2) && area <= (3.0).toFixed(2)) {
      pushScore = 5;
  }
  else if (area >= (3.1).toFixed(2) && area <= (4.0)) {
      pushScore = 6;
  }
  else if (area >= (4.1).toFixed(2) && area <= (8.0)) {
      pushScore = 7;
  }
  else if (area >= (8.1).toFixed(2) && area <= (12.0)) {
      pushScore = 8;
  }
  else if (area >= (12.1).toFixed(2) && area <= (24.0)) {
      pushScore = 9;
  }
  else if (area > 24) {
      pushScore = 10;
  }
  if (exudateAmount == exudate.light) {
      pushScore = pushScore + 1;
  } else if (exudateAmount == exudate.moderate) {
      pushScore = pushScore + 2;
  }
  else if (exudateAmount == exudate.heavy) {
      pushScore = pushScore + 3;
  }
  if (tissueTypeId == mostSevereTissue.Epithelial) {
      pushScore = pushScore + 1;
  }
  else if (tissueTypeId == mostSevereTissue.Granulation) {
      pushScore = pushScore + 2;
  }
  else if (tissueTypeId == mostSevereTissue.Slough) {
      pushScore = pushScore + 3;
  }
  else if (tissueTypeId == mostSevereTissue.Necrosis) {
      pushScore = pushScore + 4;
  }
   return pushScore;
}
// const { BlobServiceClient } = require("@azure/storage-blob");
// export async function downloadImage() {
//   try {
//   const blobServiceClient = new BlobServiceClient(blobStorageUrl + blobSas);
// const containerClient = blobServiceClient.getContainerClient(blobContainerName);
// const blobClient = containerClient.getBlobClient("ATESTFACILITY1_20220909043910_82ec4069-3b9e-4a3e-b564-7ba2ac5628e6.pdf");

// // Get blob content from position 0 to the end
// // In Node.js, get downloaded data by accessing downloadBlockBlobResponse.readableStreamBody
// const downloadBlockBlobResponse = await blobClient.download();
// // const downloaded = (
// //   await streamToBuffer(downloadBlockBlobResponse.readableStreamBody)
// // ).toString();
// const downloaded = await blobToString(await downloadBlockBlobResponse.blobBody);

//   window.print();
//       const elem = "printit";
//       var mywindow = window.open("", "PRINT", "height=400,width=600");
//       mywindow.document.write("</head><body >");
//       mywindow.document.write("</body></html>");

//       // mywindow.document.close(); // necessary for IE >= 10
//       mywindow.focus(); // necessary for IE >= 10*/

//       mywindow.print();
//       // mywindow.close();
//  return downloaded
// } catch (ex) {
//   console.log(ex,"Api Call in common.js file","uploadImage");
//   return "e";
// }

// }
//   const blobToString=async(blob) =>{
    
//   const fileReader = new FileReader();
//   return new Promise((resolve, reject) => {
//     fileReader.onloadend = (ev) => {
//       resolve(ev.target.result);
//     };
//     fileReader.onerror = reject;
//     fileReader.readAsText(blob);
//   });
// }
export class DateHelper {
  /**
   * Get current date in the format of MM/DD/YYYY
   * @param {Date} date
   * @param {string} format
   * @returns {string}
   */
  static formatDate(date, format = 'MM/DD/YYYY') {
    return moment(date).format(format);
  }
}